import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-itreview-grid',
  templateUrl: './itreview-grid.component.html',
  styleUrls: ['./itreview-grid.component.scss']
})
export class ITReviewGridComponent implements OnInit {

  constructor(public appservice:AppService,public router:Router) { }

  ngOnInit(): void {
    this.appservice.getticketcreationdata();
  }
  editEmployee(data){
  this.appservice.ticketcreationid=data;
  console.log("the edit id",data);
  this.router.navigate(['/home/Ticket-Review'])
}

}
